import { encodeParams } from "@/modules/utils";
import config from "@/config";

export function googleOauthRedirect(
  clientKey: string | undefined,
  callbackUrl = "/",
  returnUrl = "/",
  nonce: string | undefined,
  app: string | undefined
) {
  console.log("doing google oauth");
  // Google's OAuth 2.0 endpoint for requesting an access token
  const oauthEndpoint = "https://accounts.google.com/o/oauth2/v2/auth";

  // Create <form> element to submit parameters to OAuth 2.0 endpoint.
  const form = document.createElement("form");
  form.setAttribute("method", "GET"); // Send as a GET request.
  form.setAttribute("action", oauthEndpoint);

  // Parameters to pass to OAuth 2.0 endpoint.
  const params: { [key: string]: string } = {
    client_id:
      "310997303993-3tv5knj33ki2mr5ma0of454jg6mlt7dv.apps.googleusercontent.com",
    redirect_uri: location.protocol + "//" + location.host + "/oauth",
    response_type: "token",
    scope: "https://www.googleapis.com/auth/userinfo.email",
    include_granted_scopes: "true",
    //    nonce: nonce || "",
    state: encodeParams({
      clientKey,
      callbackUrl,
      returnUrl,
      app,
    }),
    prompt: "select_account",
  };

  // Add form parameters as hidden input values.
  for (const p in params) {
    const input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", p);
    input.setAttribute("value", params[p]);
    form.appendChild(input);
  }

  // Add form to page and submit it to open the OAuth 2.0 endpoint.
  document.body.appendChild(form);
  form.submit();
}
export function msOauthRedirect(
  clientKey: string | undefined,
  callbackUrl = "/",
  returnUrl = "/",
  nonce: string | undefined,
  app: string | undefined
) {
  console.log("ms oauth");
  // Microsoft OAuth 2.0 endpoint for requesting an access token
  const oauthEndpoint =
    // "https://login.microsoftonline.com/{tenant}/v2.0/oauth2/token";
    // "https://login.microsoftonline.com/8ffa5d03-35be-4a3c-9117-5ddf9b65d960/oauth2/authorize";
    "https://login.microsoftonline.com/common/oauth2/v2.0/authorize";

  // Create <form> element to submit parameters to OAuth 2.0 endpoint.
  const form = document.createElement("form");
  form.setAttribute("method", "GET"); // Send as a GET request.
  form.setAttribute("action", oauthEndpoint);

  // Parameters to pass to OAuth 2.0 endpoint.
  const params: { [key: string]: string | any } = {
    client_id: config.SSO_CLIENT_ID || "",
    scope: "user.read openid profile",
    // scope: "https://graph.microsoft.com/mail.read",
    redirect_uri: location.protocol + "//" + location.host + "/oauth",
    response_type: "id_token",
    // response_mode: "form_post",
    state: encodeParams({
      clientKey,
      callbackUrl,
      returnUrl,
      app,
    }),
    nonce,
    prompt: "select_account",
  };
  // Add form parameters as hidden input values.
  for (const p in params) {
    const input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", p);
    input.setAttribute("value", params[p]);
    form.appendChild(input);
    // form.method = "POST";
  }

  // Add form to page and submit it to open the OAuth 2.0 endpoint.
  document.body.appendChild(form);
  form.submit();
}
